import { useEffect, useState } from 'react'
import Spinner from 'app/components/Spinner'
import { gqlQuery } from 'app/lib/graphqlClient'
import { bg } from 'lib/background'
import { logWarn } from 'lib/logging'
import { graphql } from 'app/generated/gql'

let fetching: Record<string, Promise<string | undefined>> = {}
let cache: Record<string, string> = {}

const PMS_COMM_TYPE_NAME_QUERY = graphql(`
  query LazyPmsCommTypeName($locationId: ID!, $commType: Int!) {
    pmsCommTypeName(locationId: $locationId, commType: $commType)
  }
`)

function cacheKey(locationId: string, commType: number): string {
  return `${locationId}:${commType}`
}

export async function getPmsCommTypeName(locationId: string, commType: number): Promise<string | undefined> {
  const key = cacheKey(locationId, commType)
  if (cache[key] != null) return cache[key]
  if (fetching[key] != null) return fetching[key]
  if (!locationId || !commType) return
  fetching[key] = (async () => {
    try {
      const { data, error } = await gqlQuery(PMS_COMM_TYPE_NAME_QUERY, { locationId, commType })
      if (error || !data?.pmsCommTypeName) {
        logWarn(`pmsCommTypeName(${locationId}, ${commType}) returned no data`, { error })
        return undefined
      }
      return (cache[key] = data.pmsCommTypeName)
    } catch (err) {
      logWarn(`pmsCommTypeName(${locationId}, ${commType}) fetch threw`, err)
      return undefined
    }
  })()
  return fetching[key]
}

export function LazyPmsCommTypeCell(props: {
  locationId: string
  commType: number | undefined | null
  className?: string
  loadingIndicator?: boolean
}) {
  const key = props.locationId && props.commType ? cacheKey(props.locationId, props.commType) : ``
  const [name, setName] = useState<string>(key ? (cache[key] ?? ``) : ``)

  useEffect(() => {
    if (!props.locationId || !props.commType) {
      setName(``)
      return
    }
    if (name && cache[key] === name) return
    else setName(``)
    bg(
      getPmsCommTypeName(props.locationId, props.commType).then((fetched) => {
        if (fetched) setName(fetched)
      }),
    )
  }, [key])

  if (!props.commType) return null
  return name ? (
    <span className={props.className ?? 'text-body-xs'}>{name}</span>
  ) : props.loadingIndicator !== false ? (
    <Spinner size={5} />
  ) : null
}
